import React, { Component } from "react";
import { Route } from "react-router-dom";

import { RouterWrapper, Footer } from "../components";
import SiteHeader from "../components/SiteHeader";
import ScrollManager from "../components/ScrollManager/ScrollManager";
import Home from "./Home/Home";
import Category from "./Category/Category";
import Article from "./Article/Article";
import SearchRes from "./SearchRes/SearchRes";
import LegacyRedirect from "./LegacyRedirect";
import NotFound from "./NotFound/NotFound";
import "../components/Help/Help.scss";

class AppRoutes extends Component {
  /*
   * Order matters: the Switch takes the first match. `/search` and the legacy
   * `/category/...` paths have to come before `/:category`, or "search" and
   * "category" would be read as category slugs.
   */
  paths = [
    {
      title: "Home",
      id: "home",
      route: {
        exact: true,
        path: "/",
        component: Home
      }
    },
    {
      title: "Search Result",
      id: "search-result",
      route: {
        exact: true,
        path: "/search",
        component: SearchRes
      }
    },
    {
      title: "Kategori",
      id: "legacy-category",
      route: {
        path: "/category/:category?/:legacy?",
        component: LegacyRedirect
      }
    },
    {
      title: "Kategori",
      id: "category",
      route: {
        exact: true,
        path: "/:category",
        component: Category
      }
    },
    {
      title: "Pertanyaan",
      id: "article",
      route: {
        exact: true,
        path: "/:category/:article",
        component: Article
      }
    }
  ];

  render() {
    const isWebview = new URLSearchParams(window.location.search).get("webview") === "true";
    return (
      <div className={`App${isWebview ? " webview" : ""}`}>
        {isWebview ? null : <SiteHeader />}
        <ScrollManager />
        {/* No page-entry animation (visual spec section 3): the old react-reveal
            fade made every page arrive half-transparent. */}
        <main className="hc-main">
          <RouterWrapper paths={this.paths}>
            <Route component={NotFound} />
          </RouterWrapper>
        </main>
        {isWebview ? null : <Footer />}
      </div>
    );
  }
}

export default AppRoutes;
